var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"desensitize"},[_c('span',[_vm._v(_vm._s(_vm.showClearText ? _vm.textCleared : _vm.text))]),(_vm.clearText)?_c('span',{attrs:{"loading":_vm.loading},on:{"click":function($event){$event.stopPropagation();return _vm.changeMode.apply(null, arguments)}}},[_c('span',{class:{
        eyefill: _vm.showClearText,
        eyeclose: !_vm.showClearText,
        eyeicon: true,
      }})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }